<ng-container *transloco="let t; read: 'deviceLocations'">
  <section class="xs12col">
    <h2 class="padding-bottom-medium">{{t('title')}}</h2>
  </section>

  <kendo-grid
    [data]="deviceLocations$ | async"
    [resizable]="true"
    [loading]="isLoading$ | async"
    (edit)="editHandler($event)"
    (add)="addHandler($event)"
    (remove)="removeHandler($event)"
    (save)="saveHandler($event)"
    (cancel)="cancelHandler($event)">

    <ng-template kendoGridToolbarTemplate>
      <a kendoGridAddCommand class="addIcon">
        <span class="icon">
          <img src="../../../assets/icons/add-icon.svg">
        </span>
        {{t('add')}}
      </a>
    </ng-template>

    <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
      <ng-template
        kendoGridEditTemplate
        let-isNew="isNew"
        let-formGroup="formGroup"
        >
        <kendo-textbox
          [formControl]="formGroup.get('name')"
        ></kendo-textbox>
        @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
          <kendo-formerror>
          {{t('isRequired')}}</kendo-formerror>
        }
        @if (formGroup.get('name').hasError('deviceLocationExists')) {
          <kendo-formerror>
          {{t('isNotUnique')}}</kendo-formerror>
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column
      [hidden]="!('Permissions.DeviceCategories.Update' | permission) || !('Permissions.DeviceCategories.Delete' | permission)"
      media="(min-width: 993px)"
      >
      <ng-template kendoGridCellTemplate let-isNew="isNew">
        <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
        <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
          {{ isNew ? t('add') : t('save') }}
        </button>
        <button kendoGridCancelCommand>
          {{ isNew ? t('cancel') : t('cancel') }}
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <!-- MOBILE GRID -->
    <kendo-grid-column-group media="(max-width: 992px)">

      <kendo-grid-column>
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('name')}}</h4>
          <span>{{dataItem.name}}</span>
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-isNew="isNew"
          let-formGroup="formGroup">
          <h4 class="mobileGridHeader">{{t('name')}}</h4>
          <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
          @if (formGroup.get('name').hasError('required') && formGroup.get('name').touched) {
            <kendo-formerror>
              {{t('isRequired')}}
            </kendo-formerror>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column
        [hidden]="!('Permissions.DeviceCategories.Update' | permission) || !('Permissions.DeviceCategories.Delete' | permission)"
        >
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
          <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            {{ isNew ? t('add') : t('save') }}
          </button>
          <button kendoGridCancelCommand>
            {{ isNew ? t('cancel') : t('cancel') }}
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid-column-group>

    <!-- IF NO RESULTS COULD BE FOUND -->
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t("noResults") }}</div>
    </ng-template>

    <ng-template kendoGridLoadingTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>

  </kendo-grid>
</ng-container>
